export const serializeError = (error: any) => error;
